import { render, staticRenderFns } from "./ProfileUs.vue?vue&type=template&id=d12584e6&"
import script from "./ProfileUs.vue?vue&type=script&lang=js&"
export * from "./ProfileUs.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports